(() => {
  if (window.tradePricingPromptV2Initialized) return;
  window.tradePricingPromptV2Initialized = true;

  const tradePricingPattern = /\b(?:Trade Discount|Inspire Trade Member Price)\b/i;

  const hasActiveTradePricing = (productInfo) => tradePricingPattern.test(
    productInfo.querySelector('.npd-product-rating-price, [id^="price-"]')?.textContent || '',
  );

  const normalizeTradePricingCopy = (productInfo) => {
    const priceArea = productInfo.querySelector('.npd-product-rating-price, [id^="price-"]');
    if (!priceArea) return;
    const walker = document.createTreeWalker(priceArea, NodeFilter.SHOW_TEXT);
    let textNode = walker.nextNode();
    while (textNode) {
      if (/\bTrade Discount\b/i.test(textNode.nodeValue || '')) {
        textNode.nodeValue = textNode.nodeValue.replace(/\bTrade Discount\b/gi, 'Inspire Trade Member Price');
      }
      textNode = walker.nextNode();
    }
  };

  const removeDuplicateTradePricingLabels = (productInfo) => {
    const priceArea = productInfo.querySelector('.npd-product-rating-price, [id^="price-"]');
    if (!priceArea) return;
    const exactLabels = [...priceArea.querySelectorAll('*')].filter((element) => (
      element.children.length === 0
      && element.textContent.trim().toLowerCase() === 'inspire trade member price'
    ));
    exactLabels.forEach((element, index) => {
      const isDuplicate = index > 0;
      if (element.hidden !== isDuplicate) element.hidden = isDuplicate;
      element.toggleAttribute('data-duplicate-trade-price-label', isDuplicate);
    });
  };

  const updatePrompt = (productInfo) => {
    const prompt = productInfo.querySelector('[data-trade-pricing-prompt]');
    const priceNode = productInfo.querySelector('.npd-price-copy [id^="price-"]');
    const tradePricingActive = hasActiveTradePricing(productInfo);
    if (tradePricingActive) {
      normalizeTradePricingCopy(productInfo);
    }
    removeDuplicateTradePricingLabels(productInfo);
    const shippingBadge = productInfo.querySelector('[data-trade-shipping-badge]');
    if (shippingBadge) {
      const shippingText = tradePricingActive
        ? shippingBadge.dataset.tradeText
        : shippingBadge.dataset.standardText;
      if (shippingBadge.textContent.trim() !== shippingText) shippingBadge.textContent = shippingText;
    }
    if (prompt && priceNode) {
      if (prompt.previousElementSibling !== priceNode) priceNode.after(prompt);
      prompt.hidden = tradePricingActive;
    }
  };

  const updateAll = () => document.querySelectorAll('product-info').forEach(updatePrompt);
  window.refreshTradePricingPresentation = updateAll;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateAll, { once: true });
  else updateAll();
  document.addEventListener('product-info:loaded', updateAll);
  document.addEventListener('shopify:section:load', updateAll);
  new MutationObserver(updateAll).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  window.setInterval(updateAll, 750);
})();
